import Cookies from 'js-cookie';
import { createCookie } from 'react-router';

import { getCookieDomain } from '../utils/urlUtils';

export const REFERRED_SIGNUP_SUCCESS_COOKIE_NAME = 'referredSignupSuccess';

const referredSignupSuccessCookie = Cookies.withAttributes({
  expires: 365,
  domain: getCookieDomain(),
});

export const setReferredSignupSuccessfulCookie = () => {
  referredSignupSuccessCookie.set(REFERRED_SIGNUP_SUCCESS_COOKIE_NAME, '1');
};

export const deleteReferredSignupSuccessfulCookie = () => {
  referredSignupSuccessCookie.remove(REFERRED_SIGNUP_SUCCESS_COOKIE_NAME);
};

const referralSignupSuccessCookie = createCookie(
  REFERRED_SIGNUP_SUCCESS_COOKIE_NAME,
  {
    path: '/',
    httpOnly: false,
    secure: false,
    sameSite: 'lax',
  },
);

export const serializeReferredSignupSuccessfulCookieDeletion = () => {
  return referralSignupSuccessCookie.serialize('', { maxAge: 0 });
};

export const serializeReferredSignupSuccessfulCookie = () => {
  return referralSignupSuccessCookie.serialize('1');
};

export const DAPX_ORIGIN_COOKIE_NAME = 'visitor_origin';
const dapxOriginCookie = createCookie(DAPX_ORIGIN_COOKIE_NAME, {
  path: '/',
  httpOnly: false,
  secure: false,
  sameSite: 'lax',
  maxAge: 24 * 60 * 60, // 1 day
});

export const serializeOriginCookie = (visitorOrigin: string) => {
  return dapxOriginCookie.serialize(visitorOrigin);
};

export const parseOriginCookie = (cookies: string) => {
  return dapxOriginCookie.parse(cookies);
};

export const originCookieDeletion = () => {
  return dapxOriginCookie.serialize('', { maxAge: 0 });
};

export const discountCodeCookie = Cookies.withAttributes({
  expires: 1,
  domain: getCookieDomain(),
});
